module.exports = __webpack_public_path__ + "img/135.3.381d154e.png";